import React from 'react';
import { Box } from '@mui/material';
import BlockFormPercentageChartSetting from '../../../../../Components/Admin/Pages/Blocks/BlockFormPercentageChartSetting';
import NivoSchemeSelector from '../../../../../Components/Form/NivoSchemeSelector';
import { BlockSettingsProps } from './types';

export const ListOptionPercentageConditionsSettings: React.FC<BlockSettingsProps> = ({
    kedo,
    state,
    handleChangeSettings,
}) => {
    return (
        <Box sx={{ mt: 2 }}>
            <BlockFormPercentageChartSetting
                pie_charts={state.item.settings.pie_charts}
                kedo={kedo}
                onChange={(newPieCharts: any) => handleChangeSettings('pie_charts', newPieCharts)}
            />
            <NivoSchemeSelector
                kedo={kedo}
                value={state.item.settings.scheme}
                onChange={(e: any) => handleChangeSettings('scheme', e.target.value)}
                sx={{ mt: 2 }}
            />
        </Box>
    );
};